var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Dimmer, Loader } from "semantic-ui-react";
/**
 * A wrapper that throws up a dimmer until the provided `LoaderCore` produces output.
 */
var LoadWrapper = /** @class */ (function (_super) {
    __extends(LoadWrapper, _super);
    function LoadWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.loadData = function () {
            _this.setState({
                loading: true,
            }, function () {
                _this.props.loader.load()
                    .then(function (data) {
                    _this.setState({
                        loading: false,
                        data: data
                    });
                })
                    .catch(function (rej) {
                    console.error("Couldn't load data: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
        };
        return _this;
    }
    LoadWrapper.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, null,
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.data && this.props.render(this.state.data));
    };
    LoadWrapper.prototype.componentDidMount = function () {
        this.loadData();
    };
    return LoadWrapper;
}(React.PureComponent));
export { LoadWrapper };
//# sourceMappingURL=LoadWrapper.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-fish/LoadWrapper.js
// module id = 38
// module chunks = 0